import _regeneratorRuntime from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import { isNodeLike, stringToUint8Array } from "@azure/core-util";
import { createHttpHeaders } from "../httpHeaders.js";
/**
 * The programmatic identifier of the formDataPolicy.
 */

export var formDataPolicyName = "formDataPolicy";

function formDataToFormDataMap(formData) {
  var _a;

  var formDataMap = {};

  var _iterator = _createForOfIteratorHelper(formData.entries()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          value = _step$value[1];

      (_a = formDataMap[key]) !== null && _a !== void 0 ? _a : formDataMap[key] = [];
      formDataMap[key].push(value);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return formDataMap;
}
/**
 * A policy that encodes FormData on the request into the body.
 */


export function formDataPolicy() {
  return {
    name: formDataPolicyName,
    sendRequest: function () {
      var _sendRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request, next) {
        var contentType;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (isNodeLike && typeof FormData !== "undefined" && request.body instanceof FormData) {
                  request.formData = formDataToFormDataMap(request.body);
                  request.body = undefined;
                }

                if (!request.formData) {
                  _context.next = 10;
                  break;
                }

                contentType = request.headers.get("Content-Type");

                if (!(contentType && contentType.indexOf("application/x-www-form-urlencoded") !== -1)) {
                  _context.next = 7;
                  break;
                }

                request.body = wwwFormUrlEncode(request.formData);
                _context.next = 9;
                break;

              case 7:
                _context.next = 9;
                return prepareFormData(request.formData, request);

              case 9:
                request.formData = undefined;

              case 10:
                return _context.abrupt("return", next(request));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function sendRequest(_x, _x2) {
        return _sendRequest.apply(this, arguments);
      }

      return sendRequest;
    }()
  };
}

function wwwFormUrlEncode(formData) {
  var urlSearchParams = new URLSearchParams();

  for (var _i = 0, _Object$entries = Object.entries(formData); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    if (Array.isArray(value)) {
      var _iterator2 = _createForOfIteratorHelper(value),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var subValue = _step2.value;
          urlSearchParams.append(key, subValue.toString());
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    } else {
      urlSearchParams.append(key, value.toString());
    }
  }

  return urlSearchParams.toString();
}

function prepareFormData(_x3, _x4) {
  return _prepareFormData.apply(this, arguments);
}

function _prepareFormData() {
  _prepareFormData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(formData, request) {
    var contentType, parts, _i2, _Object$entries2, _Object$entries2$_i, fieldName, values, _iterator3, _step3, value, fileName, headers;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // validate content type (multipart/form-data)
            contentType = request.headers.get("Content-Type");

            if (!(contentType && !contentType.startsWith("multipart/form-data"))) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return");

          case 3:
            request.headers.set("Content-Type", contentType !== null && contentType !== void 0 ? contentType : "multipart/form-data"); // set body to MultipartRequestBody using content from FormDataMap

            parts = [];
            _i2 = 0, _Object$entries2 = Object.entries(formData);

          case 6:
            if (!(_i2 < _Object$entries2.length)) {
              _context2.next = 39;
              break;
            }

            _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2), fieldName = _Object$entries2$_i[0], values = _Object$entries2$_i[1];
            _iterator3 = _createForOfIteratorHelper(Array.isArray(values) ? values : [values]);
            _context2.prev = 9;

            _iterator3.s();

          case 11:
            if ((_step3 = _iterator3.n()).done) {
              _context2.next = 28;
              break;
            }

            value = _step3.value;

            if (!(typeof value === "string")) {
              _context2.next = 17;
              break;
            }

            parts.push({
              headers: createHttpHeaders({
                "Content-Disposition": "form-data; name=\"".concat(fieldName, "\"")
              }),
              body: stringToUint8Array(value, "utf-8")
            });
            _context2.next = 26;
            break;

          case 17:
            if (!(value === undefined || value === null || typeof value !== "object")) {
              _context2.next = 21;
              break;
            }

            throw new Error("Unexpected value for key ".concat(fieldName, ": ").concat(value, ". Value should be serialized to string first."));

          case 21:
            // using || instead of ?? here since if value.name is empty we should create a file name
            fileName = value.name || "blob";
            headers = createHttpHeaders();
            headers.set("Content-Disposition", "form-data; name=\"".concat(fieldName, "\"; filename=\"").concat(fileName, "\"")); // again, || is used since an empty value.type means the content type is unset

            headers.set("Content-Type", value.type || "application/octet-stream");
            parts.push({
              headers: headers,
              body: value
            });

          case 26:
            _context2.next = 11;
            break;

          case 28:
            _context2.next = 33;
            break;

          case 30:
            _context2.prev = 30;
            _context2.t0 = _context2["catch"](9);

            _iterator3.e(_context2.t0);

          case 33:
            _context2.prev = 33;

            _iterator3.f();

            return _context2.finish(33);

          case 36:
            _i2++;
            _context2.next = 6;
            break;

          case 39:
            request.multipartBody = {
              parts: parts
            };

          case 40:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[9, 30, 33, 36]]);
  }));
  return _prepareFormData.apply(this, arguments);
}